import { UseCase } from '../UseCase';

export namespace StorageSet {
    export interface Params<T> {
        key: string;
        value?: T;
    }
}

export class StorageSet<T> implements UseCase<StorageSet.Params<T>, void> {
    execute({ key, value }: StorageSet.Params<T>): void {
        if (value === undefined) {
            localStorage.removeItem(`mdd.${key}`);
        } else {
            localStorage.setItem(`mdd.${key}`, JSON.stringify(value));
        }
    }
}
